import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCMS } from '../context/CMSContext';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const pathname = location.pathname;

  const { globalData } = useCMS();
  const { logo, navLinks, headerCta } = globalData;

  // Determine active page key
  let activePage = '';
  if (pathname === '/' || pathname === '/index.html' || pathname === '') {
    activePage = 'home';
  } else if (pathname.includes('about')) {
    activePage = 'about';
  } else if (pathname.includes('services') || pathname.includes('service') || pathname.includes('portfolio')) {
    activePage = 'services';
  } else if (pathname.includes('team')) {
    activePage = 'team';
  } else if (pathname.includes('blog')) {
    activePage = 'blog';
  } else if (pathname.includes('contact')) {
    activePage = 'contact';
  }

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [menuOpen]);

  // Auto-close menu when route changes
  useEffect(() => {
    setMenuOpen(false);
    document.body.style.overflow = '';
  }, [pathname]);

  return (
    <>
      {menuOpen && <div className="nav-backdrop" onClick={() => setMenuOpen(false)}></div>}
      <header className={`site-header ${scrolled ? 'scrolled' : ''}`}>
        <div className="wrap">
          <a href={logo.link} className="logo">
            {logo.useSvg ? (
              <img
                src={logo.src}
                alt={logo.alt}
                width="160"
                height="32"
                style={{ height: '32px', width: 'auto', aspectRatio: '160 / 32', display: 'block' }}
                loading="eager"
                fetchPriority="high"
              />
            ) : (
              <>
                <span className="mark"></span>
                {logo.text}<span className="b">{logo.boldText}</span>
              </>
            )}
          </a>
          <nav className={`main-nav ${menuOpen ? 'open' : ''}`} id="mainNav">
            {navLinks.map((link) => (
              <a
                key={link.key}
                href={link.href}
                className={activePage === link.key ? 'active' : ''}
              >
                {link.label}
              </a>
            ))}
          </nav>
          <div className="header-cta">
            <a href={headerCta.href} className="btn btn-primary btn-sm">{headerCta.label}</a>
            <button
              className={`menu-toggle ${menuOpen ? 'active' : ''}`}
              id="menuToggle"
              aria-label="Toggle menu"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              <span></span><span></span><span></span>
            </button>
          </div>
        </div>
      </header>
    </>
  );
}
